import { useState } from "react";
import { AddFollowerPopup } from "../ActionPopup";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";

export const AddNewFollower = ({
  onStartCreate,
  onCancelCreate,
}: {
  onStartCreate?: () => void;
  onCancelCreate?: () => void;
}) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(true);
    onStartCreate?.();
  };

  const handleClose = () => {
    setShowPopup(false);
    onCancelCreate?.(); 
  };

  return (
    <>
      <div
        style={{ cursor: "pointer", height: 30 }}
        onClick={handleClick}
      >
        <PersonAddAltIcon style={{ fontSize: 30 }} />
      </div>
      {showPopup && <AddFollowerPopup close={handleClose} />}
    </>
  );
};
